import type {
  TrackSearchEventParams,
  TrackSearchSuggestionEventParams,
  TrackNoSearchSuggestionEventParams,
  TrackViewSearchResultEventParams,
  TrackingEvent,
  TrackingPayload,
} from '~/types/tracking'

const useSearchEvents = (
  track: (event: TrackingEvent, payload: TrackingPayload) => any,
) => ({
  trackStartSearch: () => {
    track('start_search', {})
  },

  trackNoSearchSuggestion: ({
    originalSearchTerm,
  }: TrackNoSearchSuggestionEventParams) => {
    track('no_search_suggestion', {
      original_search_term: originalSearchTerm,
    })
  },

  trackSearch: ({
    searchTerm,
    originalSearchTerm,
    originalSearchTermLength,
    searchAction,
    searchType,
    searchSuggestedCategories,
    searchSuggestedProducts,
    numSearchSuggestions,
    searchDestination,
  }: TrackSearchEventParams) => {
    track('search', {
      search_term: searchTerm,
      original_search_term: originalSearchTerm,
      original_search_term_length: originalSearchTermLength,
      search_action: searchAction,
      search_type: searchType,
      search_suggested_categories: JSON.stringify(searchSuggestedCategories),
      search_suggested_products: JSON.stringify(searchSuggestedProducts),
      num_search_suggestions: numSearchSuggestions,
      search_destination: searchDestination,
    })
  },

  trackViewSearchResult: ({
    searchTerm,
    numSearchResults,
    ecommerceItems,
  }: TrackViewSearchResultEventParams) => {
    track('view_search_result', {
      search_result: true,
      search_term: searchTerm,
      num_search_results: numSearchResults,
      ecommerce: {
        items: ecommerceItems,
      },
    })
  },

  trackSearchSuggestions: ({
    searchTerm,
    suggestion,
    position,
    section,
  }: TrackSearchSuggestionEventParams) => {
    track('search_suggestions_click', {
      search_term: searchTerm,
      search_suggestion: suggestion,
      search_suggestion_position: position,
      search_suggestion_section: section,
    })
  },
})

export default useSearchEvents
